import React from 'react';
import { InfoWindow } from '@react-google-maps/api';

const TrafficInfoWindow = ({ sensor, position, onClose }) => {
  if (!sensor) return null;

  const aadt = sensor.latest_aadt;
  const aadtColor =
    aadt > 60000 ? '#ef4444' :
    aadt > 30000 ? '#f97316' :
    aadt > 15000 ? '#eab308' : '#22c55e';

  return (
    <InfoWindow position={position} onCloseClick={onClose}>
      <div style={{ minWidth: 220, fontFamily: 'system-ui, sans-serif', color: '#1f2937' }}>
        <h4 style={{ margin: '0 0 8px', fontSize: 14, fontWeight: 700, borderBottom: '2px solid #3b82f6', paddingBottom: 6 }}>
          🚦 {sensor.station_id || sensor.station_name || 'Traffic Sensor'}
        </h4>
        <div style={{ fontSize: 13, lineHeight: 1.7 }}>
          <div><b>Road:</b> {sensor.road_type || 'N/A'} ({sensor.functional_class || 'N/A'})</div>
          <div>
            <b>AADT (2024):</b>{' '}
            <span style={{ color: aadtColor, fontWeight: 700 }}>
              {aadt ? aadt.toLocaleString() : 'N/A'}
            </span>{' '}
            vehicles/day
          </div>
          <div><b>Truck Traffic:</b> {sensor.truck_percentage_2024 != null ? `${sensor.truck_percentage_2024}%` : 'N/A'}</div>
          <div><b>Distance:</b> {sensor.distance_meters ? `${Math.round(sensor.distance_meters)} m` : 'N/A'}{sensor.distance_miles ? ` (${sensor.distance_miles} mi)` : ''}</div>
          {sensor.avg_growth_rate != null && (
            <div>
              <b>Growth Rate:</b>{' '}
              <span style={{ color: sensor.avg_growth_rate >= 0 ? '#22c55e' : '#ef4444' }}>
                {sensor.avg_growth_rate}%
              </span>
            </div>
          )}
        </div>
      </div>
    </InfoWindow>
  );
};

export default TrafficInfoWindow;
